import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddUserComponent } from './components/add-user/add-user.component';
import { EditUserComponent } from './components/edit-user/edit-user.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ConfirmationModalComponent } from './components/confirmation-modal/confirmation-modal.component';
import { UserModalComponent } from './components/user-modal/user-modal.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { CardTableModule } from '../../../tools/card-table/card-table.module';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { UserRoleTreeComponent } from './components/user-role-tree/user-role-tree.component';
import { ToolsModule } from 'libs/portal/src/modules/tools/tools.module';
import { MatColComponent } from 'libs/portal/src/modules/tools/mat-col/mat-col.component';
import { MatRowComponent } from 'libs/portal/src/modules/tools/mat-row/mat-row.component';
import { MatListModule } from '@angular/material/list';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTreeModule } from '@angular/material/tree';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [AddUserComponent, EditUserComponent, UserModalComponent, ConfirmationModalComponent, ChangePasswordComponent, UserRoleTreeComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, CardTableModule, ToolsModule, MatRowComponent, MatColComponent, MatListModule, MatFormFieldModule, MatIconModule, MatGridListModule, MatTreeModule, MatCheckboxModule, MatInputModule, MatButtonModule, MaterialModule],
  exports: [AddUserComponent, EditUserComponent, UserModalComponent, ConfirmationModalComponent, ChangePasswordComponent, UserRoleTreeComponent],

})
export class UserModule { }
